import { load } from '@/util/router-utils.js'

import history from './history'
import reports from './reports'
import settings from './settings'
import stocks from './stocks'

export default [
  {
    path: 'farms/:farm_id',
    redirect: 'farms/:farm_id/planning',
    component: load('app/client/farm/Index'),
    children: [
      {
        path: 'planning',
        component: load('app/client/farm/planning/Index')
      },
      {
        path: 'planning/leftovers',
        components: {
          default: load('app/client/farm/planning/leftovers/Index')
        }
      },
      {
        path: 'kkz',
        component: load('app/client/farm/kkz/Index')
      },
      {
        path: 'animal-groups',
        component: load('app/client/farm/animal-groups/Index')
      },
      {
        path: 'rations',
        component: load('app/client/farm/rations/Index')
      },
      ...history,
      ...reports,
      ...settings,
      ...stocks
    ]
  }
]
